module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "powered-by-akash.cf0ce61b.svg";